import _CartContainer from './CartContainer'
import _CartCopyContainer from './CartCopyContainer'

export const CartContainer = _CartContainer
export const CartCopyContainer = _CartCopyContainer

export default { CartContainer, CartCopyContainer }
